// Mini cart upsell
// Originally Jquery. Updated in LYRA81

document.addEventListener('DOMContentLoaded', function () {
  // Initialize Swiper if needed
  // const swiper = new Swiper('.mini-cart_upsell', {
  //   loop: false,
  //   slidesPerView: 1.2,
  //   spaceBetween: 20
  // });

  changHeight();
  upSellSlider({
    gap: 10,
    slidesCountPerView: 2.5,
    breakpoints: {
      0: {
        slidesCountPerView: 2.8,
        gap: 10
      },
      768: {
        slidesCountPerView: 3,
      }
    }
  });

  document.addEventListener('click', async function (event) {
    if (event.target.classList.contains('mini-cart_upsell-button')) {
      const id = event.target.dataset.variantId;
      const params = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'quantity=1&id=' + id
      };

      try {
        const response = await fetch('/cart/add.js', params);
        if (response.ok) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          // Initialize Swiper if needed
          // const swiper = new Swiper('.mini-cart_upsell', {
          //   loop: false,
          //   slidesPerView: 1.2,
          //   spaceBetween: 20
          // });
          upSellSlider({
            gap: 10,
            slidesCountPerView: 2.5,
            breakpoints: {
              0: {
                slidesCountPerView: 2.8,
                gap: 10
              },
              768: {
                slidesCountPerView: 3,
              }
            }
          });
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }
  });
});

// Handle window resize
window.addEventListener('resize', () => {
  changHeight();
});

// Set interval for height adjustment
let miniCartHeightHandle = setInterval(() => {
  changHeight();
  upSellSlider({
    gap: 10,
    slidesCountPerView: 2.5,
    breakpoints: {
      0: {
        slidesCountPerView: 2.8,
        gap: 10
      },
      768: {
        slidesCountPerView: 3,
      }
    }
  });
}, 1000);